/* eslint class-methods-use-this: "off"  */

import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import './LanguageMenu.css';

class LanguageMenu extends React.Component {
  renderVoiceOption(voice, index) {
    return <MenuItem className="menu-language-option" key={index} value={index} label={voice.languageName} primaryText={`${voice.languageName} - ${voice.voice.name}`} />;
  }

  render() {
    const isActive = this.props.isStopped();

    return (
      <SelectField
        id="pronounce-language-menu"
        className="pronounce-language-menu"
        autoWidth
        disabled={!isActive}
        value={this.props.activeVoice}
        onChange={(e, index, value) => this.props.selectVoice(value)}
      >
        {this.props.voices.map(this.renderVoiceOption)}
      </SelectField>
    );
  }
}

export default LanguageMenu;



// WEBPACK FOOTER //
// ./src/components/LanguageMenu.js